import "./MainPage.css";
import { Link } from "react-router-dom";

function MainPage() {
  return (
    <main className="container">
      <div className="row">
        <div className="col-md">
          <Link to="/about" exact>
            <div className="about box">
              <p>About me</p>
            </div>
          </Link>
          <div className="row" style={{'margin-top':'2em'}}>
          <Link to="/portfolio" exact>
            <div className="portfolio box">
              <p>Portfolio</p>
            </div>
          </Link>
          <Link to="/academy" exact>
            <div className="academy box">
              <p>Academy</p>
            </div>
          </Link>
          </div>
        </div>
        <div className="col-md">
        <Link to="/contact" exact>
            <div className="contact box">
              <p>Contact me</p>
            </div>
          </Link>
          <Link to="/resume" exact>
            <div className="resume box" style={{'margin-top':'2em'}}> 
              <p>Resume</p>
            </div>
          </Link>
        </div>
      </div>
    </main>
  );
}

export default MainPage;
